import { render, staticRenderFns } from "./UserSettingsBody.vue?vue&type=template&id=e4fbd898&scoped=true"
import script from "./UserSettingsBody.vue?vue&type=script&lang=js"
export * from "./UserSettingsBody.vue?vue&type=script&lang=js"
import style0 from "./UserSettingsBody.vue?vue&type=style&index=0&id=e4fbd898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fbd898",
  null
  
)

export default component.exports